import HeatSupplyIcon from './component'

export default HeatSupplyIcon
